export default function createDocumentIdAndRef({ api, env }, { collection, id }) {
	const c = api.convertFromLiveToStage ? api.stage.db.collection(collection) : api[env].db.collection(collection);

	let ref;

	if (id) {
		ref = c.doc(id);
	} else {
		ref = c.doc();
	}

	return { id: ref.id, ref };
}
